/**
 * Het bestand van een gespreksexport. CC5 (23 oktober 2026): Word en PDF komen als base64
 * met hun eigen mime-type; Markdown en JSON als tekst, zoals voorheen. PUUR.
 */
export function exportBlob(data, format) {
  if (data && data.encoding === "base64") {
    const bytes = Uint8Array.from(atob(data.content || ""), (c) => c.charCodeAt(0));
    return new Blob([bytes], { type: data.mime || "application/octet-stream" });
  }
  const json = format === "json";
  return new Blob([json ? JSON.stringify(data?.content, null, 2) : data?.content ?? ""],
    { type: json ? "application/json" : "text/markdown" });
}
